export const alertError = msg => {
  const $warning = $(".alert.alert-warning");
  $warning.addClass("in").html(msg);
  setTimeout(() => {
    $warning.removeClass("in");
  }, 4000);
};

const errorMessage = () => {
  $(document)
    .ajaxError((_, xhr) => {
      alertError(xhr.responseText);
    })
    .on("ajax:error", event => {
      alertError(JSON.stringify(event.detail[0]));
    });
};

export default errorMessage;
